module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-blog"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-dark"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('message.title.site.blog')))])])], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content og-bg-light"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.auth.admin),
      expression: "this.$store.state.auth.admin"
    }]
  }, [_c('b-button', {
    attrs: {
      "size": 'large',
      "variant": 'secondary',
      "to": {
        name: 'Article',
        params: {
          id: 'create_new'
        }
      }
    }
  }, [_vm._v("add article")]), _vm._v(" "), _c('br'), _vm._v(" \n        ")], 1), _vm._v(" "), _vm._l((_vm.articles), function(article) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Article',
          params: {
            id: article.id
          }
        }
      }
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v("(by " + _vm._s(article.author) + ")")])], 1)
  })], 2)]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f27f2478"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/BlogList.vue
// module id = 1224
// module chunks = 1